import { jsxs, jsx } from "react/jsx-runtime";
import { RadioInput } from "./Styles.js";
const DEFAULT_NAME = "boolValue";
const Radio = ({
  id = DEFAULT_NAME,
  name = DEFAULT_NAME,
  value,
  label,
  onChange,
  autoFocus,
  disabled
}) => {
  return /* @__PURE__ */ jsxs(RadioInput, { disabled, children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        autoFocus,
        type: "radio",
        id,
        value,
        name,
        onChange,
        disabled
      }
    ),
    label && /* @__PURE__ */ jsx("label", { htmlFor: id, children: label })
  ] });
};
export {
  Radio
};
